module.exports = __webpack_public_path__ + "img/video_shrink_close.6bee90d5.svg";